
import { AssetPreviewTabInstructionsController } from './asset-preview-tab-instructions.controller'

function assetPreviewTabInstructions () {
  return {
    restrict: 'E',
    scope: {
      template: '<'
    },
    templateUrl: '/core/directives/asset-preview-tab-instructions/asset-preview-tab-instructions.html?$$REVISION$$',
    controller: AssetPreviewTabInstructionsController
  }
}
export { assetPreviewTabInstructions }
